// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"ContentFeedField_mainContainer__3E_od","fileDropContainer":"ContentFeedField_fileDropContainer__2q24K","fileDropLink":"ContentFeedField_fileDropLink__1-iEg"};